import {IStateService} from 'angular-ui-router';
import VersicherungRS from '../../../core/service/versicherungRS.rest';
import VersicherungsbeitragModelManager from '../../../core/service/VersicherungsbeitragModelManager';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {TSEigentumsverhaeltnis} from '../../../models/enums/TSEigentumsverhaeltnis';
import {isStatusInBearbeitung, TSVersicherungsbeitragStatus} from '../../../models/enums/TSVersicherungsbeitragStatus';
import TSGesuchsteller from '../../../models/TSGesuchsteller';
import TSVersicherung from '../../../models/TSVersicherung';
import TSVersicherungsbeitrag from '../../../models/TSVersicherungsbeitrag';
import DVBernUtil from '../../../utils/DVBernUtil';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./versicherungsbeitragVersicherterView.scss');
let template = require('./versicherungsbeitragVersicherterView.html');

export class VersicherungsbeitragVersicherterViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = VersicherungsbeitragVersicherterViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        versicherungsbeitrag: '<'
    };
}

export class VersicherungsbeitragVersicherterViewController extends AbstractGesuchViewController<TSVersicherungsbeitrag> {

    versicherungsbeitrag: TSVersicherungsbeitrag;
    form: IFormController;
    readonly: boolean;
    possibleVersicherungen: Array<TSVersicherung> = [];
    doctype: TSDocumentType = TSDocumentType.VERSICHERUNGSBEITRAG_DOC;

    static $inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log', '$state', 'VersicherungsbeitragModelManager', 'VersicherungRS'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private  $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private versicherungsbeitragModelManager: VersicherungsbeitragModelManager,
                private versicherungRS: VersicherungRS) {
        super($scope);
    }

    $onInit() {
        super.$onInit();
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag();
            // this.versicherungsbeitrag.versicherungsbeitragDatenFS = new TSVersicherungsbeitragDaten();
            // this.versicherungsbeitrag.versicherungsbeitragStundenDaten = [];
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        } else {
            this.initialModel = this.versicherungsbeitrag;
            this.model = angular.copy(this.versicherungsbeitrag);
        }
        this.readonly = !isStatusInBearbeitung(this.model.status);

        if (!this.model.gesuchsteller) {
            this.model.gesuchsteller = new TSGesuchsteller();
        }
        this.model.gesuchsteller.eigentumsverhaeltnis = TSEigentumsverhaeltnis.VERSICHERTER;
    }

    public saveVersicherungsbeitrag() {
        if (this.isModelValid() && this.model) {
            this.model.gesuchsteller.cleanup();
            this.model.status = TSVersicherungsbeitragStatus.IN_BEARBEITUNG_FS; //nach speichern in Zustand Bearbeitung
            this.versicherungsbeitragModelManager.saveVersicherungsbeitrag(this.getModel()).then((result: TSVersicherungsbeitrag) => {
                this.$state.go('versicherungbeitragbeitrag', {versicherungsbeitragId: result.id})
            });
        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelVersicherungsbeitrag() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('versicherungsbeitraege')

    }

    public getViewTitle(): string {
        return this.dvBernUtil.getVersicherungsbeitragViewTitle(this.model);
    }


}



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/component/versicherungsbeitragVersicherterView/versicherungsbeitragVersicherterView.ts